import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Loading } from '../../../common/loading'
import { Panel } from '../../../common/panel'
import { selectPeriod } from '../../common/period/slice'
import { GroupNote } from '../common/html/GroupNote'
import { VALUE_SCORE } from '../constant'
import { selectScoreActive } from '../store/slice'
import { Chart } from './chart'
import { SelectViewBy } from './common/SelectViewBy'
import { VALUE_VIEW_BY } from './constant'
import {
  selectActivePortfolio,
  selectLoading,
  selectViewBy,
} from './store/slice'
import {
  exportTrendByPortfolioCreditRiskScore,
  exportTrendByPortfolioPerformanceScore,
  getTrendByPortfolioCreditRisk,
  getTrendByPortfolioPerformanceScore,
} from './store/thunk'
import { TableTrendPort } from './table'

const TEXT_BY_TYPE_SCORE = {
  [VALUE_SCORE.CREDIT_SCORE]: {
    title: 'portfolioScore.titleCredit',
    textNote: 'portfolioScore.textNoteCredit',
  },
  [VALUE_SCORE.PERFORMANCE]: {
    title: 'portfolioScore.titlePerformance',
    textNote: 'portfolioScore.textNotePerformance',
  },
}

export const TrendByPortfolio = () => {
  const dispatch = useDispatch()

  const { value: typeValue } = useSelector(selectScoreActive)
  const settingParams = useSettingParams()
  const portfolioId1 = useSelector(selectActivePortfolio('activePortfolio1'))
  const portfolioId2 = useSelector(selectActivePortfolio('activePortfolio2'))
  const period = useSelector(selectPeriod)
  const loading = useSelector(selectLoading)
  const viewBy = useSelector(selectViewBy)
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    if (typeValue === VALUE_SCORE.CREDIT_SCORE) {
      dispatch(
        getTrendByPortfolioCreditRisk({
          portfolioId1: portfolioId1.value,
          portfolioId2: portfolioId2.value,
          timeFrequency: period,
          ...settingParams,
        }),
      )
    }

    if (typeValue === VALUE_SCORE.PERFORMANCE) {
      dispatch(
        getTrendByPortfolioPerformanceScore({
          portfolioId1: portfolioId1.value,
          portfolioId2: portfolioId2.value,
          timeFrequency: period,
          ...settingParams,
        }),
      )
    }
  }, [
    settingParams,
    portfolioId1.value,
    portfolioId2.value,
    period,
    locale,
    typeValue,
  ])

  return (
    <Panel
      label={TEXT_BY_TYPE_SCORE[typeValue].title}
      headerStyle={{
        textTransform: 'capitalize',
      }}
      isI18n
      renderRightHeader={() => <SelectViewBy />}
      downloadCsv={{
        downloadFunc: () =>
          typeValue === VALUE_SCORE.CREDIT_SCORE
            ? exportTrendByPortfolioCreditRiskScore({
                portfolioId1: portfolioId1.value,
                portfolioId2: portfolioId2.value,
                timeFrequency: period,
                ...settingParams,
              })
            : exportTrendByPortfolioPerformanceScore({
                portfolioId1: portfolioId1.value,
                portfolioId2: portfolioId2.value,
                timeFrequency: period,
                ...settingParams,
              }),
      }}
      downloadJpgParams={{
        arrName: [UseI18n(TEXT_BY_TYPE_SCORE[typeValue].title)],
        titleJpg: UseI18n(TEXT_BY_TYPE_SCORE[typeValue].title),
        domId: 'trendByPortfolioId',
      }}
    >
      {loading ? (
        <div className="positionRelative" style={{ height: 200 }}>
          <Loading />
        </div>
      ) : (
        <>
          <GroupNote title={TEXT_BY_TYPE_SCORE[typeValue].textNote} />
          {viewBy.value === VALUE_VIEW_BY.CHART ? (
            <Chart />
          ) : (
            <TableTrendPort />
          )}
        </>
      )}
    </Panel>
  )
}
